/* eslint-disable prettier/prettier */
<!--
 * @Author: your name
 * @Date: 2020-11-11 09:54:06
 * @LastEditTime: 2020-11-23 20:34:39
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/home/components/StoreDet/index.vue
-->
<template>
  <!-- 头部店铺信息 -->
  <div
    :style="{ backgroundImage: `url(${findStoreByCondition.shopUrl})` }"
    class="store_con"
  >
    <!-- 上部信息 -->
    <div class="shop_top">
      <div class="filter_blur"></div>
      <div class="shop_bor border_bottom1px">
        <div class="top_left text_left">
          <img :src="findStoreByCondition.avatarUrl" alt="" />
          <div class="info_width">
            <div class="font16 font_weight500 colo087 line_height_22 shop_name">
              {{ findStoreByCondition.name }}
            </div>
            <div class="font12 font_weight400 colo055 line_height_17 shop_det">
              {{ findStoreByCondition.intro }}
            </div>
          </div>
        </div>
        <img
          v-if="findStoreByCondition.isShowLogo"
          :src="require(`@/assets/${$G('@/')}home/az_logo@2x.png`)"
          alt=""
          class="shop_share"
        />
      </div>
    </div>
    <!-- 下部信息 -->
    <van-sticky>
      <div class="shop_bottom">
        <div class="bot_search" @click="goSearch">
          <img src="@/assets/common/search@2x.png" alt="" />
          <span class="font14 font_weight400 colo038 line_height_24">搜索</span>
        </div>
        <div class="bot_list" @click="clickTab('theme')">
          <div
            :class="{ line_color: clickIndex === 'theme' }"
            class="font14 font_weight400 colo087 line_height_20 bor_title"
          >
            <a href="#theme">主题清单</a>
          </div>
          <div v-if="clickIndex === 'theme'" class="line"></div>
        </div>
        <div class="bot_list" @click="clickTab('all')">
          <div
            :class="{ line_color: clickIndex === 'all' }"
            class="font14 font_weight400 colo087 line_height_20 bor_title"
          >
            <a href="#all">全部商品</a>
          </div>
          <div v-if="clickIndex === 'all'" class="line"></div>
        </div>
      </div>
    </van-sticky>
  </div>
</template>
<script>
export default {
  props: {
    clickIndex: {
      type: String,
      default: "",
    },
  },
  // data() {
  //   return {
  //     clickIndex: "theme"
  //   };
  // },
  computed: {
    findStoreByCondition() {
      return this.$store.getters.findStoreByCondition;
    },
  },
  methods: {
    goSearch() {
      this.$emit("goSearch");
    },
    clickTab(value) {
      // this.clickIndex = value;
      this.$emit("clickTab", value);
    },
  },
};
</script>
<style lang="less" scoped>
.store_con {
  // background-image: url("../../../../assets/home/shop_bg@2x.png");
  background-size: 100% 126px;
  padding-top: 90px;
  background-repeat: no-repeat;
  .shop_top {
    position: relative;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 16px 16px 0px 0px;
    padding: 0 12px;
    .filter_blur {
      background: rgba(255, 255, 255, 0.9);
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      filter: blur(20px);
      z-index: -1;
    }
    .shop_bor {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 3px;
    }
    .top_left {
      display: flex;
      img {
        width: 50px;
        height: 50px;
        border-radius: 10px;
        margin-right: 12px;
      }
      .shop_det {
        margin-top: 8px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .shop_name {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .info_width {
        max-width: 180px;
      }
    }
    .shop_share {
      width: 73px;
    }
  }
  .shop_bottom {
    background: #fff;
    box-shadow: 0px 3px 3px 0px rgba(193, 200, 207, 0.2);
    border-radius: 0px 0px 16px 16px;
    padding: 0 16px;
    display: flex;
    justify-content: flex-start;
    .bot_search {
      background: rgba(0, 0, 0, 0.05);
      border-radius: 14px;
      padding: 2px 14px 2px 10px;
      display: flex;
      align-items: center;
      margin: 12px 20px 12px 0;
      img {
        width: 24px;
        margin-right: 4px;
      }
    }
    .bot_list {
      margin-right: 20px;
      .bor_title {
        padding: 15px 0 17px;
      }
      .line {
        height: 2px;
        width: 100%;
        background: var(--linear-gradient);
        border-radius: 2px;
      }
      .line_color {
        color: var(--primary-color) !important;
        a {
          text-decoration: none;
          color: var(--primary-color);
        }
        a:link {
          text-decoration: none;
          color: var(--primary-color);
        }
        a:visited {
          text-decoration: none;
          color: var(--primary-color);
        }
        a:hover {
          text-decoration: none;
          color: var(--primary-color);
        }
        a:active {
          text-decoration: none;
          color: var(--primary-color);
        }
      }
      a {
        text-decoration: none;
        color: rgba(0, 0, 0, 0.87);
      }
      a:link {
        text-decoration: none;
        color: rgba(0, 0, 0, 0.87);
      }
      a:visited {
        text-decoration: none;
        color: rgba(0, 0, 0, 0.87);
      }
      a:hover {
        text-decoration: none;
        color: rgba(0, 0, 0, 0.87);
      }
      a:active {
        text-decoration: none;
        color: rgba(0, 0, 0, 0.87);
        font-size: 14px;
      }
    }
  }
}
</style>
